import Vue from 'vue'

declare module 'vue/types/vue' {
    interface Vue {
        $server_address: string
    }
}

const globalVar = {
    install: (Vue:any,options:any) => {
        if(process.env.NODE_ENV === 'production'){
            //Vue.prototype.$server_address='https://stgevent.wou.edu.my:5001'; // DEV PUBLISH
            Vue.prototype.$server_address='https://ems.wou.edu.my:5001'; // LIVE SERVER
        }
        else{
            Vue.prototype.$server_address='https://localhost:5001'; // TESTING
        }  
    }
}

export default globalVar;




